<app-header></app-header>
<div class="app-shell" [class.mobile-menu-open]="isMobileMenuOpen">
  <div class="sidebar-drawer-wrapper">
    <app-sidebar></app-sidebar>
    <app-sub-sidebar></app-sub-sidebar>
  </div>

  @if (isMobileMenuOpen) {
    <div class="mobile-backdrop" (click)="closeMobileMenu()"></div>
  }

  <div class="content" cdkScrollable>
    <div class="formcontent">
      <div class="formContainer" [class.is-dashboard]="isDashboardPage">
        @if (isDashboardPage) {
          <div class="content-bg-gradient"></div>
        }
        <div class="form-actual-content">
          <div [class.loading-skeleton]="isLoading$ | async">
            <router-outlet />
          </div>
        </div>
      </div>
    </div>
    <!-- <app-footer></app-footer> -->
  </div>
</div>
